export const GET_DOCUMENTS_LIST="GET_DOCUMENTS_LIST"
export const GET_DOCUMENTS_LIST_SUCCESS="GET_DOCUMENTS_LIST_SUCCESS"
export const GET_DOCUMENTS_LIST_FAILED="GET_DOCUMENTS_LIST_FAILED"
export const ADD_DOCUMENT="ADD_DOCUMENT"
export const ADD_DOCUMENTS_SUCCESS="ADD_DOCUMENT_SUCCESS"
export const ADD_DOCUMENT_FAILED="ADD_DOCUMENT_FAILED"
export const EDIT_DOCUMENT="EDIT_DOCUMENT"
export const EDIT_DOCUMENTS_SUCCESS="EDIT_DOCUMENT_SUCCESS"
export const EDIT_DOCUMENT_FAILED="EDIT_DOCUMENT_FAILED"
export const CHANGE_THE_DOC_STATUS="CHANGE_THE_DOC_STATUS"
export const CHANGE_THE_DOC_STATUS_SUCCESS="CHANGE_THE_DOC_STATUS_SUCCESS"
export const CHANGE_THE_DOC_STATUS_FAILED="CHANGE_THE_DOC_STATUS_FAILED"
export const ADD_THE_VERIFICATION_DOCS="SEND_THE_VERIFICATION_DOCS"
export const ADD_THE_VERIFICATION_DOCS_SUCCESS="SEND_THE_VERIFICATION_DOCS_SUCCESS"
export const ADD_THE_VERIFICATION_DOCS_FAILED="SEND_THE_VERIFICATION_DOCS_FAILED"
export const GET_VERIFICATION_DOC_DETAILS="GET_VERIFICATION_DOC_DETAILS"
export const GET_VERIFICATION_DOC_DETAILS_SUCCESS="GET_VERIFICATION_DOC_DETAILS_SUCCESS"
export const GET_VERIFICATION_DOC_DETAILS_FAILED="GET_VERIFICATION_DOC_DETAILS_FAILED"
export const SUBMIT_DOC_STATUS="SUBMIT_DOC_STATUS"
export const SUBMIT_DOC_STATUS_SUCCESS="SUBMIT_DOC_STATUS_SUCCESS"
export const SUBMIT_DOC_STATUS_FAILED="SUBMIT_DOC_STATUS_FAILED"

